import React from "react";
import { FormButton, TextInput } from "../../component/styled";

const InputField = ({
  label,
  hasButton,
  readOnly,
  itemKey,
  value,
  onChange,
  buttonClick = null,
}) => {
  return (
    <li className={itemKey}>
      <span className="tit">{label}</span>
      <div className="cont">
        <TextInput
          type={itemKey.toLowerCase().includes("password") ? "password" : "text"}
          readOnly={readOnly}
          value={value}
          onChange={onChange}
          name={itemKey}
        />
        {hasButton && <button onClick={buttonClick}>{hasButton}</button>}
      </div>
    </li>
  );
};

export default InputField;
